import { Routes } from '@angular/router';
import { RequestComponent } from './request/request.component';
import { RequestDetailComponent } from './request-detail/request-detail.component';
import { canActivateAdmin, canActivateUser } from '@shs-digi-care-monorepo/frontend-lib';
import { MenuComponent } from './menu/menu.component';
import { TasksComponent } from './requests/tasks.component';

export const APP_ROUTES: Routes = [
    {
        path: '',
        component: MenuComponent
    },
    {
        path: 'request',
        component: RequestComponent
    },
    {
        path: 'request/:id',
        component: RequestDetailComponent
    },
    {
        path: 'requests',
        component: TasksComponent,
        data: { mode: 'requests' }
    },
    {
        path: 'tasks',
        component: TasksComponent,
        data: { mode: 'tasks' }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [canActivateUser, canActivateAdmin]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [canActivateUser]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
